import { Box } from "@mui/material";
import TkSelectForm from "../../../components/atoms/TkSelectForm";
import { useEffect, useMemo, useState } from "react";
import CheckBoxGroupForFakeTableLine from "../../../components/atoms/TkFakeTableLine/components/checkBoxGroupForFakeTableLine";
import { IAPI_STA034_Response } from "../../../type/apiType";
import _ from "lodash";
import { checkboxList } from "../parts";
import TkFakeTableLine from "../../../components/atoms/TkFakeTableLine";
import dayjs from "dayjs";
import { getFiscalYear } from "../../../utils/useTools";
import { TkCheckboxProps } from "../../../type/componentsType/TkCheckbox";
import { UnrecognizedMonthList } from "../../../type/apiType/IAPI_STA034";
import { Status } from "../../../assets/data/Constants";

interface ISCRW070004ComponentsProps {
  res: IAPI_STA034_Response;
  onChange: (value?: UnrecognizedMonthList[]) => void;
}

/**
 * ならない月チェックボックス部品
 */
export const SCRW070004Components: React.FC<ISCRW070004ComponentsProps> = ({
  res,
  onChange,
}) => {
  const [stateUnrecognizedMonthList, setStateUnrecognizedMonthList] =
    useState<UnrecognizedMonthList[]>();
  const [stateCheckBoxList, setStateCheckBoxList] = useState<TkCheckboxProps[]>(
    []
  );
  const [year, setYear] = useState(0);

  useEffect(() => {
    setStateUnrecognizedMonthList(res.unrecognizedMonthList);
  }, [res]);

  // 年度プルダウン
  const selectPropsList = useMemo(() => {
    const list =
      res.unrecognizedMonthList?.map((item) => ({
        value: item.year!.toString(),
        label: item.year!.toString() + "年",
      })) ?? [];

    return list;
  }, [res]);

  const handleYearChange = (e: any) => {
    let selectedYear = e.target.value?.length ? e.target.value : 0;
    setYear(parseInt(selectedYear));
  };

  const handleChange = (e: any) => {
    if (!e || !year) {
      setStateCheckBoxList((prev) =>
        prev.map((item) => ({ ...item, disabled: true }))
      );
      return;
    }

    let value: any = {};
    checkboxList.forEach((item) => {
      if (item.key === "none") return;

      let initValue = res.unrecognizedMonthList?.find((i) => i.year === year)?.[
        item.key as keyof (typeof res.unrecognizedMonthList)[0]
      ]!;
      value[item.key] =
        initValue === "2" || initValue === "3"
          ? initValue
          : e.includes(item.label)
          ? "1"
          : "0";
    });
    let newUnrecognizedMonthList = stateUnrecognizedMonthList?.map((item) =>
      year === item.year ? { year, ...value } : item
    );
    if (!_.isEqual(newUnrecognizedMonthList, stateUnrecognizedMonthList)) {
      setStateUnrecognizedMonthList(newUnrecognizedMonthList);
    }
  };

  const handleSetValue = (): string[] => {
    if (!year) return ["無"];

    let newCheckboxList = _.clone(checkboxList);
    const target = stateUnrecognizedMonthList?.find(
      (item) => item.year === year
    );
    const returnValue = [];
    if (target) {
      Object.entries(target).forEach(([key, value]) => {
        if (value === "1" || value === "3") {
          returnValue.push(
            checkboxList.find((item) => item.key === key)?.label
          );
        }

        let check = newCheckboxList.find((item) => item.key === key);
        if (check) {
          let nowMonth = check.label?.replace("月", "").padStart(2, "0");
          let nowYear = Number(nowMonth) > 3 ? year : year + 1;
          check.disabled =
            (res.latestApplyStatus !== Status["届出待ち"] &&
              res.latestApplyStatus !== Status["差戻し一時保存"]) ||
            value === "2" ||
            value === "3" ||
            (getFiscalYear(res.retireDate) === year &&
              ((dayjs(`${nowYear}${nowMonth}`).format("YYYYMM") ===
                dayjs(res.retireDate).format("YYYYMM") &&
                dayjs(res.retireDate).date() <= 10) ||
                (getFiscalYear(res.retireDate) === year &&
                  dayjs(`${nowYear}${nowMonth}`).isAfter(
                    dayjs(res.retireDate)
                  ))));
        }
      });
      if (!returnValue.length) {
        returnValue.push("無");
      }
    }

    if (!_.isEqual(newCheckboxList, stateCheckBoxList)) {
      setStateCheckBoxList(newCheckboxList);
    }

    return returnValue;
  };

  useEffect(() => {
    onChange(stateUnrecognizedMonthList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateUnrecognizedMonthList]);

  return (
    <TkFakeTableLine
      title="ならない月"
      type="nodeInLine"
      node={
        <Box>
          <TkSelectForm
            selectPropsList={selectPropsList}
            wantToSetValue={selectPropsList[selectPropsList.length - 1]?.value}
            onChange={handleYearChange}
          />
          <CheckBoxGroupForFakeTableLine
            checkBoxList={stateCheckBoxList}
            onChange={handleChange}
            wantToSetValue={handleSetValue()}
          />
        </Box>
      }
    />
  );
};
